module.exports = __webpack_public_path__ + "static/media/career_tab_img_2.be72c77a.png";